export class ScreenUtils {
  public static getScreenResolution(): number {
    return window.innerWidth;
  }

  public static scrollToIdByResolution(event: string, resolutionLimit: number): void {
    if (ScreenUtils.getScreenResolution() < resolutionLimit)
      setTimeout(() => {
        document.getElementById(event.replaceAll(' ', '').toLowerCase())?.scrollIntoView();
      }, 50);
  }

  public static scrollToId(event: string) {
    setTimeout(() => {
      document.getElementById(event.replaceAll(' ', '').toLowerCase())?.scrollIntoView();
    }, 50);
  }
}
